import React, { useState } from "react";
import { useForm } from "react-hook-form";
import AuthImage from "../assets/images/climate.jpg";

export function Tool() {

  
  const { Submit, handleSubmit } = useForm();
  const [file, setFile] = useState(null);
  const [processedFileUrl, setProcessedFileUrl] = useState(null);


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.endsWith(".csv")) {
      setFile(selectedFile);
    } else {
      alert("Please upload a valid CSV file.");
    }
  };


  const onSubmit = handleSubmit(async () => {
    if (!file) {
      alert("Please upload a CSV file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch("https://api.climate-solutions.net/upload", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("File processing failed");
      }

      const blob = await response.blob();
      console.log(file);
      const url = window.URL.createObjectURL(blob);
      setProcessedFileUrl(url);
      alert("File processed successfully!");
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while processing the file.");
    }
  });

  const downloadFile = () => {
    if (processedFileUrl) {
      const a = document.createElement("a");
      a.href = processedFileUrl;
      a.download = file.name.replace(/\.csv$/, "")+"_CLEAN.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      alert("No processed file available to download.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-2 bg-white font-montserrat">
      <main className="flex flex-col items-center justify-center w-full flex-1 px-6 md:px-20 text-center">
        <div
          style={{ width: "1000px", height: "400px" }}
          className="flex flex-col lg:flex-row w-full lg:w-2/3 max-w-5xl bg-white rounded-[10px] border border-gray-300"
        >
          <div className="w-full lg:w-1/2 p-6">
            <form onSubmit={onSubmit} className="mt-[30px]">
              <div className="py-6 md:py-10 md:mr-[200px] mb-[20px]">
                <h2 className="text-2xl md:text-3xl font-extrabold">
                  <span className="text-black">HAPEx Cleaner</span>
                </h2>
              </div>

              <div>
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileChange}
                  className="w-full py-3 mb-4 pl-3 bg-indigo-600 hover:bg-indigo-800 text-white text-sm font-bold uppercase tracking-widest rounded-lg cursor-pointer"
                />
                <button
                  type="submit"
                  className="w-full py-3 flex mb-3 justify-center items-center bg-white hover:bg-gray-100 border border-gray-300 text-black text-sm font-bold uppercase rounded-lg"
                >
                  Process CSV File
                </button>
                <button
                  type="button"
                  className="w-full py-3 flex justify-center items-center bg-white hover:bg-gray-100 border border-gray-300 text-black text-sm font-bold uppercase rounded-lg"
                  onClick={downloadFile}
                >
                  Download Processed File
                </button>
              </div>
            </form>
            <p className="text-black text-[14px] mt-2 ml-[20px] text-right font-bold">
                     <a href="https://climate-solutions.net/" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 underline">Climate-solutions.net</a>
              </p>
          </div>
          <div
            className="w-full lg:w-1/2 text-white rounded-b-[10px] lg:rounded-r-[10px] lg:rounded-bl-none p-12 flex items-center justify-center"
            style={{
              backgroundImage: `url('${AuthImage}')`,
              backgroundPosition: "center",
              marginTop: "120px",
              width: "500px",
              height: "150px",
            }}
          />
        </div>
      </main>
    </div>
  );
}